import React, { useEffect, useState } from 'react';
import { useNavigate   } from "react-router-dom";
import {SvgDelete, SvgMod, SvgAtivo, SvgInativo, SvgSairMenu } from "../Svg.js"
import { Link } from 'react-router-dom'; 


function FormUsuarioGrid() {
   const [clientes, setClientes] = useState([]);
  const navigate = useNavigate(); // Inicialize o hook

  const handleAtivo = async (id, ativo) => {
    //alert("Ativo"+id+" "+ativo);

    try {
      const response = await fetch(`http://www.criar.com.br:3000/usuativar/${id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}), 
      });
      //alert(response.status);
      if (response.status === 200) {
        const data = await response.text();
        console.log(data);
        //alert(data);
        navigate(0);
      } else { alert('Erro ao deletar cliente.'+response.status); }
    } catch (error) { alert('Erro no servidor.', error);}
  };


  const handleDelete = async (id) => {
    const userConfirmed = window.confirm("Você deseja Apagar o id:"+id+"?");
    if (userConfirmed) {
    try {
      const response = await fetch(`http://www.criar.com.br:3000/usudelete/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}), // Pode passar dados no corpo, se necessário
      });
      //alert(response.status);
      if (response.status === 200) {
        const data = await response.text();
        console.log(data);
        alert(data);
        navigate(0);
      } else { alert('Erro ao deletar cliente.'+response.status); }
    } catch (error) { alert('Erro no servidor.', error);}
  }
}

  useEffect(() => {
      fetch('http://www.criar.com.br:3000/usu')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Erro na resposta da API');
          }
          return response.json();
        })
        .then((data) => setClientes(data.ClienteLogin))
        .catch((error) => console.error('Erro ao buscar os dados:', error));
        }); 
  return (
    
    <div id = "texto2"> 
      <table class="tableGrid">
        <thead>
          <tr>
            <th>Id</th>
            <th>Tipo</th>
            <th>E-mail</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {clientes.map((cliente) => (
            <tr key={cliente.Id}>
              <td>{cliente.Id}</td>
              <td>{cliente.Tipo}</td>
              <td>{cliente.email}</td>
              
              <td>
                
              &nbsp;&nbsp;<Link to="#Aqui" onClick={() => handleAtivo(cliente.Id, cliente.Ativo)}>
              {cliente.Ativo === 1 ? <SvgAtivo /> : <SvgInativo />}</Link>

              &nbsp;&nbsp;<Link to="#Aqui" onClick={() => handleDelete(cliente.Id)}><SvgDelete/></Link>
              &nbsp;&nbsp;<Link to={`FormUsuarioModulo?id=${cliente.Id}`}><SvgMod/></Link>&nbsp;
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button class="botaocinsa"    onClick={() => {window.location.href = "./area"; }}><SvgSairMenu /><br/>Menu</button><br/>

    </div>
  );
}



export default FormUsuarioGrid;